<div class="link-patient-page" [class.content-desktop]="isPage">
  <div [class.pasi-card]="isPage">
    <form #linkPatientForm="ngForm"
          id="linkPatient"
          name="linkPatient"
          (ngSubmit)="onSubmit()">
      <div class="container-fluid px-0">
        <div class="row">
          <div class="col-12 mb-3 pasi-title">
            <div>{{'SI_COMPLETE_DATA_TITLE' | translate}}</div>
          </div>
          <div class="col-12 mb-3">
            <div [innerHTML]="'SI_COMPLETE_DATA_MATCH' | translate"></div>
          </div>
          <ng-container *ngIf="displayModeNHC !== registerDisplayModes.HIDE">
            <div class="col-12 col-lg-6" [class.mb-4]="displayModeHealthCard !== registerDisplayModes.HIDE">
              <si-input id="linkPatientClinicHistory"
                        name="linkPatientClinicHistory"
                        text="SI_CLINIC_HISTORY"
                        placeholder="SI_WRITE_HERE"
                        [(model)]="model.personalData.nhc"
                        tooltipIcon="icosun-help_circle font-color-main3-dark"
                        tooltipText="SI_NHC_CENTER"
                        tooltipPosition="right"
                        [rule]="(displayModeNHC === registerDisplayModes.MANDATORY) ? 'generic.fieldNotNull' : ''"
              ></si-input>
            </div>
            <div class="w-100"></div>
          </ng-container>
          <ng-container *ngIf="displayModeHealthCard !== registerDisplayModes.HIDE">
            <div class="col-12 col-sm-4 col-lg-2">
              <si-selector id="linkPatientHealthCardType"
                            name="linkPatientHealthCardType"
                            text="SI_HEALTH_CARD"
                            placeholder="SI_SELECT_PLACEHOLDER"
                            [(model)]="model.personalData.healthCardDocument.type"
                            (modelChange)="onChangeHealthCardDocumentType()"
                            path="/api/v1/identificationDocument/healthCard"
                            [showClear]="false"
                            [rule]="(displayModeHealthCard === registerDisplayModes.MANDATORY) ? 'generic.fieldNotNull' : ''"
              ></si-selector>
            </div>
            <div class="col-12 col-sm-8 col-lg-4 link-patient-page_double-line">
              <si-input id="linkPatientHealthCardValue"
                        name="linkPatientHealthCardValue"
                        placeholder="SI_WRITE_HERE"
                        [(model)]="model.personalData.healthCardDocument.value"
                        [hideLabel]="true"
                        [disabled]="!model.personalData.healthCardDocument.type"
                        [ruleRegex]="model.personalData.healthCardDocument.type?.regex"
                        ruleRegexErrorText="SI_RULES_ERROR_FORMAT"
                        [rule]="(displayModeHealthCard === registerDisplayModes.MANDATORY) ? 'generic.fieldNotNull' : ''"
              ></si-input>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="container-fluid px-0 mt-4">
        <div class="row no-gutters">
          <div class="col-12 col-sm-auto mb-3 mb-sm-0 pr-sm-1">
            <button class="si-button_main w-100"
                    translate="SI_SAVE"
                    type="submit"
                    [disabled]="linkPatientForm?.invalid"
            ></button>
          </div>
          <div *siExternalReference="false" class="col-12 col-sm-auto mb-3 mb-sm-0 pr-sm-1 pl-sm-1">
            <si-go-to-route-button text="SI_REQUEST_BE_PHONED"
                                   [href]="['/request/phoned']"
                                   styleClass="si-button_secondary w-100"
            ></si-go-to-route-button>
          </div>
          <div class="col-12 col-sm-auto pl-sm-1">
            <button class="si-button_cancel w-100"
                    translate="SI_AT_ANOTHER_TIME"
                    type="button"
                    (click)="onClickButtonCancel()"
            ></button>
          </div>
        </div>
      </div>
      <ng-container *ngIf="displayLinkPatientErrorDialog">
        <si-generic-dialog [(displayDialog)]="displayLinkPatientErrorDialog"
                            dialogTitle="SI_LINK_VALIDATION_FAIL"
                            dialogImg="assets/images/user_not_found.svg"
                            [dialogText]="linkPatientErrorText"
                            button1Text="SI_CLOSE"
                            button1Class="si-button_secondary"
        ></si-generic-dialog>
      </ng-container>
      <ng-container *ngIf="displayLinkPatientSuccessDialog">
        <si-generic-dialog [(displayDialog)]="displayLinkPatientSuccessDialog"
                            dialogTitle="SI_LINKED_USER"
                            dialogImg="assets/images/user_history.svg"
                            dialogText="SI_LINKED_USER_TEXT"
                            button1Text="CORE_ACCEPT"
                            button1Class="si-button_main"
                            (displayDialogChange)="onLinkPatientSuccess($event)"
        ></si-generic-dialog>
      </ng-container>
    </form>
  </div>
</div>
